import { render, staticRenderFns } from "./complaint-details-page.vue?vue&type=template&id=0f3d0d18"
import script from "./complaint-details-page.vue?vue&type=script&lang=js"
export * from "./complaint-details-page.vue?vue&type=script&lang=js"
import style0 from "./complaint-details.scss?vue&type=style&index=0&prod&lang=sass&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports